// Cell values: 'true' renders a checkmark, '-' renders a dash, anything else
// renders verbatim. Rows are keyed by plan key so the table can render whichever
// plans belong to the active audience.
// Keep in sync with `compareGroups` in mcg-next-site src/lib/pricing.ts.

const T = 'true'
const F = '-'

// Column order: plus, pro, marketing, inapp.
const row = (name, plus, pro, marketing, inapp) => ({
  name,
  plus,
  pro,
  marketing,
  inapp,
})

const U = 'Unlimited'
const SEAT = '3,000 per seat'

export const features = [
  {
    category: 'Creating',
    visible: false,
    options: [

      row('# of courses', U, U, U, U),
      row('Drag & Drop Block Builder', T, T, T, T),
      row('Layout Customization', T, T, T, T),
      row('Issuing Digital Badges', T, T, T, T),
      row('Landing Pages', T, T, T, T),
      row('AI Course Creator', T, T, T, T),
      row('AI YouTube-to-Course Builder', T, T, T, T),
      row('AI Lesson Page Generator', T, T, T, T),
      row('AI Interaction Builder', T, T, T, T),
      row('AI Educational Game Builder', T, T, T, T),
      row('In-page AI-Assistant', T, T, T, T),
      row('Community Boards', T, T, T, T),
      row('AI Moderator', T, T, T, T),
      row('Paths, Badges & Rewards', T, T, T, T),
      row('# of AI Credits Per Month', '1,000', '3,000', SEAT, SEAT),
      row('AI Course Translation', F, T, T, T),
      row('SCORM Upload', F, T, T, T),
    ],
  },
  {
    category: 'Delivering',
    visible: false,
    options: [

      row('Learner Count Per Year', '500', '1,000', '5,000', '5,000'),
      row('Sharing With Links', T, T, T, T),
      row('Embedding on Webpages', T, T, T, T),
      row('Custom Domains (CNAME)', '1', '3', U, U),
      row('Export to PDF', T, T, T, T),
      row('Removal of Mini Course Generator Badge', T, T, T, T),
      row('Accessibility Widget for ADA', T, T, T, T),
      row('AI Voice Over', T, T, T, T),
      row('Export to Dynamic SCORM', F, T, T, T),
      row('Embeddable Widgets', F, F, T, T),
    ],
  },
  {
    category: 'Granting Access',
    visible: false,
    options: [

      row('Grant Access to Everyone (No Login)', T, T, T, T),
      row('Grant Access After Password Wall', T, T, T, T),
      row('Grant Access After Email Verification', T, T, T, T),
      row('Grant Access After Payment', T, T, T, T),
      row('Grant Access Only with Invitation', F, T, T, T),
      row('Grant Access in Intercom via MCG App', F, F, F, T),
      row('Grant Access Through In-App Authentication', F, F, F, T),
      row('Headless LMS for Mobile and Web Apps', F, F, F, T),
    ],
  },
  {
    category: 'Managing & Integrations',
    visible: true,
    options: [

      row('SEO Settings for Landing Pages', T, T, T, T),
      row('Adding .js Codes to Head & Body', T, T, T, T),
      row('Automations with Zapier & Make Integrations', T, T, T, T),
      row('Collaboration', T, T, T, T),
      row('Analytics & Reporting', T, T, T, T),
      row('Certifications', F, T, T, T),
      row('Webhooks', F, T, T, T),
      row('Team Seats', F, F, '3', U),
      row('REST API', F, F, 'Basic', 'Full'),
      row("Account Based Reporting for Customer's Admin", F, F, F, T),
      row('Single Sign-On (SSO)', F, F, F, T),
      row('Enterprise SLA', F, F, F, T),
      row('Dedicated Customer Success Manager', F, F, F, T),
    ],
  },
]
